<span [innerHTML]="priceHTML"></span>
<lib-price-levels 
  *ngIf="displayPriceLevels && !hidePrice && priceLevelsDisplayType !== 'HIDDEN'"
  [price]="price"
  [useStaffedPrice]="useStaffedPrice"
  [priceLevelsDisplayType]="priceLevelsDisplayType"
></lib-price-levels>